import React from 'react'
import { MenuItem } from '@mui/material'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import INPUT_FORMAT_OPTIONS from './options'
import './index.scss'

export {
  TEXT_FORMAT_PLAIN_TEXT,
  TEXT_FORMAT_BASIC_HTML,
  TEXT_FORMAT_RESTRICTED_HTML,
  TEXT_FORMAT_FULL_HTML,
  TEXT_FORMAT_MARKDOWN,
} from './constants'

export default function TextInputFormatSelect (props) {
  const {
    id,
    value,
    defaultValue,
    disabled,
    label = 'Input Format',
    name = 'textInputFormat',
    className,
    onChange,
  } = props
  return (
    <MuiSelectWrapper
      id={id}
      name={name}
      className={className}
      label={label}
      onChange={onChange}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
    >
      {INPUT_FORMAT_OPTIONS.map((option) => (
        <MenuItem value={option.get('value')} key={`text-input-format-${option.get('value')}`}>
          {option.get('label')}
        </MenuItem>
      ))}
    </MuiSelectWrapper>
  )
}
